import './footerpage.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useNavigate } from 'react-router-dom';

const Footerpage = () => {
  return (
    <footer>
        <div className="socialNetwork">
          <a href='https://www.facebook.com/Casa-Gourmet-Doces-e-Salgados-100498642753423'><FacebookIcon/></a>
          <a href='https://www.instagram.com/casagourmetds/'><InstagramIcon /></a>
          <a href='https://twitter.com/'><TwitterIcon /></a>
        </div>
    </footer>
  )
}

export default Footerpage